import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { concatMap, from, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { API_KEY, BASE_URL } from '../../core/global/constants';
import { LoginResult } from '../models/login';

@Injectable({
    providedIn: 'root',
})
export class LoginService {

    constructor(
        @Inject(BASE_URL) private baseUrlProvider: string,
        @Inject(API_KEY) private apiKeyProvider: string,
        private http: HttpClient
    ) {}

    validateLogin(): Observable<LoginResult> {
        const data = {
            clearExistingSession: true,
            usr: {
                EntityTypeId: '6D6C84AF-A441-40C3-9C95-353083BE6A3F',
                UserName: 'apikey',
                Password: '',
            },
        };

        return from(this.apiKeyProvider).pipe(
            concatMap((apiKey) => {
                data.usr.Password = apiKey;
                return from(this.baseUrlProvider);
            })
        ).pipe(
            switchMap(baseUrl =>
                this.http.post(baseUrl + 'ValidateLogin', data) as Observable<LoginResult>
            )
        );
    }
}
